import api from '../config/api';

const SESSION_KEY = 'partnerSupportSession';
const PREVIOUS_TOKEN_KEY = 'partnerSupportPreviousToken';
const PREVIOUS_PARTNER_KEY = 'partnerSupportPreviousPartner';

export const PARTNER_SUPPORT_EVENT = 'partner-support-session-change';

const notifyChange = () => {
  window.dispatchEvent(new Event(PARTNER_SUPPORT_EVENT));
};

export function getPartnerSupportSession() {
  try {
    const session = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    if (!session?.partnerId) return null;
    return session;
  } catch (error) {
    return null;
  }
}

export function isPartnerSupportSessionExpired(session, now = Date.now()) {
  return Boolean(session?.expiresAt) && now >= session.expiresAt;
}

/**
 * Swap the stored partner session for an admin support session. The admin's
 * own partner login (if any) is kept aside and restored on exit.
 */
export function beginPartnerSupportSession({ token, partner, expiresInSeconds }, now = Date.now()) {
  if (!getPartnerSupportSession()) {
    const previousToken = localStorage.getItem('partnerToken');
    const previousPartner = localStorage.getItem('partner');
    if (previousToken) localStorage.setItem(PREVIOUS_TOKEN_KEY, previousToken);
    if (previousPartner) localStorage.setItem(PREVIOUS_PARTNER_KEY, previousPartner);
  }
  localStorage.setItem('partnerToken', token);
  localStorage.setItem('partner', JSON.stringify(partner));
  localStorage.setItem(SESSION_KEY, JSON.stringify({
    partnerId: partner.id,
    companyName: partner.company_name,
    expiresAt: now + (Number(expiresInSeconds) || 0) * 1000,
  }));
  notifyChange();
}

export function endPartnerSupportSession() {
  const previousToken = localStorage.getItem(PREVIOUS_TOKEN_KEY);
  const previousPartner = localStorage.getItem(PREVIOUS_PARTNER_KEY);
  if (previousToken) {
    localStorage.setItem('partnerToken', previousToken);
  } else {
    localStorage.removeItem('partnerToken');
  }
  if (previousPartner) {
    localStorage.setItem('partner', previousPartner);
  } else {
    localStorage.removeItem('partner');
  }
  localStorage.removeItem(PREVIOUS_TOKEN_KEY);
  localStorage.removeItem(PREVIOUS_PARTNER_KEY);
  localStorage.removeItem(SESSION_KEY);
  notifyChange();
}

export async function startPartnerSupportSession(partnerId) {
  const response = await api.post(`/admin/partners/${partnerId}/support-session`);
  if (!response.data?.token || !response.data?.partner) {
    throw new Error('Support session response is missing a token');
  }
  beginPartnerSupportSession(response.data);
  return response.data;
}
